import { z } from 'zod'
import { NotificationType } from '../../enums/notification-type.enum'

// the four bot notification types that support per-broker-account overrides. an override forces a
// type on/off for one account; a null override inherits the user-level Telegram preference.
export const BOT_NOTIFICATION_TYPES = [
  NotificationType.BOT_ORDER,
  NotificationType.BOT_LOW_BALANCE,
  NotificationType.BOT_INSUFFICIENT_FUNDS,
  NotificationType.BOT_API_ERROR,
] as const

export const botNotificationTypeSchema = z.enum(BOT_NOTIFICATION_TYPES)
export type BotNotificationType = z.infer<typeof botNotificationTypeSchema>

// one row of the resolved overrides view: the stored override (null = inherit), the user's
// profile-level preference, and the effective value the bot will honour (override ?? profile).
export const botNotificationOverrideSchema = z.object({
  type: botNotificationTypeSchema,
  override: z.boolean().nullable(),
  profileEnabled: z.boolean(),
  effective: z.boolean(),
})
export type BotNotificationOverrideDto = z.infer<typeof botNotificationOverrideSchema>

export const botNotificationOverridesSchema = z.object({
  overrides: z.array(botNotificationOverrideSchema),
})
export type BotNotificationOverridesDto = z.infer<typeof botNotificationOverridesSchema>

// update payload: each entry sets an explicit override (true/false) or resets a type to inherit
// the profile setting (null).
export const updateBotNotificationOverridesSchema = z.object({
  overrides: z
    .array(
      z.object({
        type: botNotificationTypeSchema,
        enabled: z.boolean().nullable(),
      })
    )
    .min(1),
})
export type UpdateBotNotificationOverridesDto = z.infer<typeof updateBotNotificationOverridesSchema>
